import { commonPromise } from '@/api/index'

const base = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : ''

async function request(path, data) {
  const response = await commonPromise({
    url: `${base}/oa/approval${path}`,
    method: 'post',
    data
  })
  if (response.code !== 0) throw new Error(response.message || '附件上传失败')
  return response.data
}

function readPart(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result).split(',')[1])
    reader.onerror = () => reject(new Error('读取附件失败，请重新选择'))
    reader.readAsDataURL(blob)
  })
}

export async function uploadApprovalAttachment(file) {
  if (!file || !file.size || file.size > 500 * 1024 * 1024) throw new Error('附件不能为空，单文件最大500MB')
  const session = await request('/attachments/chunks/init', {fileName: file.name, fileSize: file.size})
  try {
    for (let i = 0; i < session.partCount; i++) {
      const start = i * session.partSize
      const data = await readPart(file.slice(start, Math.min(file.size, start + session.partSize)))
      await request(`/attachments/chunks/${session.id}/parts/${i}`, {data})
    }
    return await request(`/attachments/chunks/${session.id}/complete`, {})
  } catch (error) {
    await request(`/attachments/chunks/${session.id}/cancel`, {}).catch(() => {})
    throw error
  }
}
